module.exports = __webpack_public_path__ + "img/aircraft-carrier.5fa86e13.jpg";